import type { Grid, MathConfig, Rng, SymbolDef, SymbolId } from '../types';

/** One uniform stop index per reel. */
export function randomStops(config: MathConfig, rng: Rng): number[] {
  return config.strips.map((strip) => rng.nextInt(strip.length));
}

/** grid[reel][row] = strip[(stop + row) % strip.length] */
export function gridFromStops(config: MathConfig, stops: number[]): Grid {
  return config.strips.map((strip, reel) => {
    const n = strip.length;
    const stop = ((stops[reel] % n) + n) % n;
    const column: SymbolId[] = [];
    for (let row = 0; row < config.rows; row++) column.push(strip[(stop + row) % n]);
    return column;
  });
}

export function symbolMap(config: MathConfig): Map<SymbolId, SymbolDef> {
  return new Map(config.symbols.map((s) => [s.id, s]));
}
